import { routes } from "router"
import { MODULES, hasModuleAccess } from "./permissions"

export const getStaffUserDefaultRoute = (permissions) => {
  if (!permissions || Object.keys(permissions)?.length === 0) {
    return routes.forbidden403()
  }

  const modulePriorityOrder = [
    { module: MODULES.CALENDAR, path: routes.proCalendarPath() },
    { module: MODULES.BOOKINGS, path: routes.guideBookingsPath() },
    { module: MODULES.CLIENTS, path: routes.guideClientsPath() },
    { module: MODULES.MESSAGES, path: routes.proMessagesRootPath() },
    { module: MODULES.EXPERIENCES, path: routes.proExperiencesPath() },
    { module: MODULES.EQUIPMENT, path: routes.guideResourcesEquipmentPath() },
    { module: MODULES.CREW, path: routes.guideResourcesCrewPath() },
    { module: MODULES.ACCOUNTING, path: routes.guideAccountingPath() },
    { module: MODULES.MARKETING, path: routes.guideMarketingPath() }
  ]
  for (const { module, path } of modulePriorityOrder) {
    if (hasModuleAccess(permissions, module)) {
      return path
    }
  }

  return routes.guideAIDashboardPath()
}
